<template>
  <div>

    <ul class="person">
      <router-link :to="'/days/' + $route.params.day + '/' + $route.params.session">
        <li>
          <table>
            <tbody>
            <tr>
              <td>Sess. time</td>
              <td>{{ session.start_time }} &ndash; {{ session.end_time }}</td>
            </tr>
            <tr>
              <td>Sess. room</td>
              <td>{{ session.room.name }}</td>
            </tr>
            <tr v-if="session.session_group">
              <td>Sess. group</td>
              <td>{{ session.session_group.name }}</td>
            </tr>
            <tr class="type" v-if="session.session_type">
              <td>Sess. type</td>
              <td>
                  <span class="type"
                        :style="{ color: session.session_type.value.color, background: session.session_type.value.background }">
                    {{ session.session_type.name }}
                  </span>
              </td>
            </tr>
            <tr class="title">
              <td>Sess. title</td>
              <td>
                <b>{{ session.code }} {{ session.title }}</b>
              </td>
            </tr>
            <tr class="title" v-if="session.content.comment">
              <td>Comment</td>
              <td>
                <b style="color:red">{{ session.content.comment }} </b>
              </td>
            </tr>
            <tr class="title">
              <td>Q&A Inbox</td>
              <td>
                <a :href="session.qanda_link" target="_blank"><b>Click here to see the questions from the
                  audience</b></a>
              </td>
            </tr>
            <tr class="persons" v-if="session.persons.length">
              <td></td>
              <td>
                <ul v-if="session.persons.length">
                  <li v-for="(pval, pkey) in session.persons" :key="pkey">
                    {{ pval.role.name }}:
                    {{ pval.person.title }}
                    {{ pval.person.first_name }}
                    {{ pval.person.last_name }}
                    <span v-if="pval.person.city || pval.person.country">
                        <span>(</span>
                        <span v-if="pval.person.city">{{ pval.person.city }}</span>
                        <span v-if="pval.person.city && pval.person.country">, </span>
                        <span v-if="pval.person.country">{{ pval.person.country.wording.value }}</span>
                        <span>)</span>
                      </span>
                  </li>
                </ul>
              </td>
            </tr>
            </tbody>
          </table>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-left']"/>
          </span>
        </li>
      </router-link>
      <router-link :to="'/days/' + $route.params.day + '/' + $route.params.session + '/' + $route.params.presentation">
        <li>
          <table>
            <tbody>
            <tr>
              <td>Pres. ID</td>
              <td>{{ presentation.id }}</td>
            </tr>
            <tr>
              <td>Pres. time</td>
              <td>{{ presentation.start_time }} &ndash; {{ presentation.end_time }}</td>
            </tr>
            <tr>
              <td>Pres. title</td>
              <td><b>{{ presentation.code }} {{ presentation.title }}</b></td>
            </tr>
            <tr v-if="presentation.content && presentation.content.comment">
              <td>Pres. comment</td>
              <td><b style="color:red">{{ presentation.content.comment }}</b></td>
            </tr>
            <tr v-if="presentation.content && presentation.content.comment_sound">
              <td>Sound source</td>
              <td><b style="color:red">{{ presentation.content.comment_sound }}</b></td>
            </tr>
            <tr v-if="presentation.content && presentation.content.comment_video">
              <td>Camera notice</td>
              <td><b style="color:red">{{ presentation.content.comment_video }}</b></td>
            </tr>
            <tr v-if="presentation.content && presentation.content.comment_location">
              <td>External / Studio</td>
              <td><b style="color:red">{{ presentation.content.comment_location }}</b></td>
            </tr>
            </tbody>
          </table>
          <span class="arrow">
            <font-awesome-icon :icon="['fas', 'angle-left']"/>
          </span>
        </li>
      </router-link>
    </ul>

    <div class="action current">
      <div>
        <div>
          <table>
            <tbody>
            <tr v-if="person.person.title">
              <td>Title</td>
              <td>{{ person.person.title }}</td>
            </tr>
            <tr>
              <td>First name</td>
              <td><b>{{ person.person.first_name }}</b></td>
            </tr>
            <tr>
              <td>Last name</td>
              <td><b>{{ person.person.last_name }}</b></td>
            </tr>
            </tbody>
            <tbody class="affiliation" v-if="person.person.institution || person.person.city || person.person.country">
            <tr v-if="person.person.institution">
              <td>Institution</td>
              <td>{{ person.person.institution }}</td>
            </tr>
            <tr v-if="person.person.city">
              <td>City</td>
              <td>{{ person.person.city }}</td>
            </tr>
            <tr v-if="person.person.country">
              <td>Country</td>
              <td>{{ person.person.country.wording.value }}</td>
            </tr>
            </tbody>
            <tbody class="contact">
            <tr v-if="person.person.phone">
              <td>Phone</td>
              <td>{{ person.person.phone }}</td>
            </tr>
            <tr v-if="person.person.mobile">
              <td>Mobile</td>
              <td>{{ person.person.mobile }}</td>
            </tr>
            <tr v-if="person.person.email">
              <td>Email</td>
              <td><a :href="'mailto:' + person.person.email">{{ person.person.email }}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="person.person.content && person.person.content.photo_id" style="margin-left:auto;">
          <a :href="'https://fileserver.documedias.systems/' + person.person.content.photo_id" target="_blank">
            <img
                :src="'https://fileserver.documedias.systems/' + person.person.content.photo_id"/>
          </a>
        </div>
      </div>
    </div>

    <div class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Info</td>
              <td>
                <span v-html="getInfo()"></span>
                <span class="icon ml-3" @click="toClipboard(getInfo())"><font-awesome-icon
                    :icon="['fad', 'clipboard']"/></span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="presentation.video_link" class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Video Preview</td>
              <td>
                <a :href="presentation.video_link" target="_blank">{{ presentation.video_link }}</a>
                <span class="icon ml-3" @click="toClipboard(presentation.video_link)"><font-awesome-icon
                    :icon="['fad', 'clipboard']"/></span>
                <a :href="presentation.video_link" target="_blank"><span class="icon"><font-awesome-icon
                    :icon="['fad', 'eye']"/></span></a>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Video Download</td>
              <td>
                <a :href="videoDownloadLink" target="_blank">{{ videoDownloadLink }}</a>
                <span class="icon ml-3" @click="toClipboard(videoDownloadLink)">
                  <font-awesome-icon :icon="['fad', 'clipboard']"/>
                </span>
                <a :href="videoDownloadLink" target="_blank">
                  <span class="icon"><font-awesome-icon :icon="['fad', 'download']"/></span>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="presentation.slides_id" class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Slides</td>
              <td>
                <a :href="'https://fileserver.documedias.systems/file/' + presentation.slides_id">https://fileserver.documedias.systems/file/{{
                    presentation.slides_id
                  }}</a>
                <span class="icon ml-3"
                      @click="toClipboard('https://fileserver.documedias.systems/file/' + presentation.slides_id)"><font-awesome-icon
                    :icon="['fad', 'clipboard']"/></span>
                <a :href="api_url.replace(/api/, '') + 'slides/' + presentation.slides_id" target="_blank"><span
                    class="icon"><font-awesome-icon :icon="['fad', 'download']"/></span></a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Regie Comment</td>
              <td>
                <b-form-input v-model="person.director_comment" placeholder="Comment ..."
                              style="width:450px;"></b-form-input>
              </td>
              <td>
                <button type="submit" class="btn btn-primary  ml-2" @click.prevent="saveComment()"> Save
                  Comment
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Vmix call password</td>
              <td>
                <b-form-input v-model="meeting" placeholder="Vmix call password ..."
                              @change="getPreview()"></b-form-input>
              </td>
            </tr>
            </tbody>
            <!--tbody class="controller">
              <tr>
                <td>Internet clicker code</td>
                <td>
                  <b-form-input v-model="controller" placeholder="Internet clicker code ..." @change="getPreview()"></b-form-input>
                </td>
              </tr>
            </tbody-->
            <tbody class="support">
            <tr>
              <td>Contact number</td>
              <td>
                <b-form-input v-model="support" placeholder="Contact number ..." @change="getPreview()"></b-form-input>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td>Preview</td>
              <td>
                <span v-html="preview"></span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="action">
      <div>
        <div>
          <table>
            <tbody>
            <tr>
              <td></td>
              <td>
                <b-button class="button" @click.prevent="sendInvitation({
                    session: session,
                    presentation: presentation,
                    person: person, 
                    meeting: meeting, 
                    /*controller: controller,*/
                    support: support 
                  })">Send
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {API_URL} from '@/config'
import {mapState, mapActions, mapMutations} from 'vuex'

export default {
  data() {
    return {
      session: null,
      presentation: null,
      person: null,
      meeting: '',
      controller: '',
      preview: '',
      api_url: API_URL,
      videoDownloadLink: null,
    }
  },
  computed: {
    ...mapState(['token', 'sessions', 'presentations', 'activeSupport']),

    support: {
      // getter
      get: function () {
        return this.activeSupport
      },
      // setter
      set: function (newValue) {
        this.setActiveSupport(newValue);
      }
    }
  },
  methods: {
    ...mapActions(['sendInvitation', 'setComment']),
    ...mapActions('videoUpload', ['requestDownloadLink']),
    ...mapMutations(['setActiveSupport']),

    getSession() {
      this.session = this.sessions.find(session => session.id == this.$route.params.session);
      let appid_prefix = 'da7ad0c0-3ed1-4500-1308-0'
      let appid_base = 10000000000;
      let final_id = appid_base + parseInt(this.session.id);
      let qanda_link = 'https://interactive.documedias.com/#/1308/sessions/' + appid_prefix + final_id + '/questions'
      this.session.qanda_link = qanda_link;
    },
    getPresentation() {
      this.presentation = this.presentations.find(presentation => presentation.id == this.$route.params.presentation);
      if (this.presentation.video_link) {
        let video_id = this.presentation.video_link.split('video/')[1].split('?')[0];
        this.presentation.video_download_link = 'https://vimeo.com/' + video_id;
      }
    },
    getPerson() {
      this.person = this.presentation.persons.find(person => person.id == this.$route.params.person);
    },
    async getPreview() {
      this.setActiveSupport(this.support)
      let preview = '';
      try {
        preview = await this.axios.get(API_URL + '/preview', {
          headers: {
            token: this.token
          },
          params: {
            session: this.session.id,
            presentation: this.presentation.id,
            person: this.person.id,
            meeting: this.meeting,
            /*controller: this.controller,*/
            support: this.support,
          },
        });
      } catch (error) {
        this.$router.push('/error');
      }
      this.preview = preview.data;
      this.setProgress(false);
    },
    async getDownloadLink(){
      this.videoDownloadLink = await this.requestDownloadLink({participation:this.presentation});
      console.log('DLLINK',this.videoDownloadLink);
    },
    getInfo() {
      let info = '<b>';
      // if (this.person.person.title) info += this.person.person.title;
      info += this.person.person.first_name + ' ' + this.person.person.last_name + '</b><br>';
      info += this.presentation.code + ' ' + this.presentation.title;
      return info;
    },
    toClipboard(text) {
      navigator.clipboard.writeText(text);
    },
    saveComment() {
      this.setComment({id: this.$route.params.person, type: 'persons', comment: this.person.director_comment});
    }
  },
  created() {
    this.getSession();
    this.getPresentation();
    this.getPerson();
    this.getPreview();
    this.getDownloadLink();
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/colors';

.person {
  padding: 0;
  margin: 0;

  > a > li {
    list-style: none;
    padding: 13px 16px 12px 16px;
    border-bottom: 1px solid #e4e4e4;
    position: relative;

    > table {
      border: 0;
      border-spacing: 0;
      border-collapse: collapse;
      min-width: 800px;

      > tbody {
        > tr {
          > td {
            padding: 2px 0;

            &:first-child {
              width: 150px;
            }

            > .type {
              display: inline-block;
              margin-left: -2px;
              padding: 3px 2px 2px 2px;
              border-radius: 3px;
            }
          }

          &.type > td {
            padding: 0;
          }

          &.title > td {
            padding-top: 10px;
          }

          &.persons > td {
            padding-top: 10px;

            > ul {
              padding: 0;

              > li {
                list-style: none;
              }
            }
          }
        }
      }
    }

    > .arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-13px);
      right: 16px;
      display: inline-block;
      height: 100%;
      font-size: 24px;
      opacity: .3;
    }

    > .persons {
      margin: 8px 0 0 0;
      padding: 0;

      > li {
        list-style: none;
      }
    }
  }

  > a:hover {
    text-decoration: none;

    > li {
      background: lighten($conference-color, 95%);

      .arrow {
        opacity: 1;
      }
    }
  }
}

.action {
  &.current {
    background: #f4f4f4;
  }

  > p {
    margin: 13px 16px;
  }

  > div {
    display: flex;

    > div {
      > table {
        border: 0;
        border-spacing: 0;
        border-collapse: collapse;
        margin: 13px 16px 12px 16px;
        min-width: 600px;

        > tbody {
          &.affiliation > tr:first-child > td,
          &.contact > tr:first-child > td,
          &.controller > tr:first-child > td,
          &.support > tr:first-child > td {
            padding-top: 10px;
          }

          > tr {
            > td {
              padding: 2px 0;

              &:first-child {
                width: 150px;
              }

              > .type {
                display: inline-block;
                margin-left: -2px;
                padding: 3px 2px 2px 2px;
                border-radius: 3px;
              }

              > .icon {
                display: inline-block;
                color: #018fd1;
                cursor: pointer;
              }

              > button {
                border-color: #018fd1;
                background: #018fd1;
              }

              p:last-child {
                margin-bottom: 0;
              }
            }

            &.type > td {
              padding: 0;
            }

            &.title > td {
              padding-top: 10px;
            }

            &.persons > td {
              padding-top: 10px;

              > ul {
                padding: 0;

                > li {
                  list-style: none;
                }
              }
            }
          }
        }
      }

      img {
        margin: 12px 16px;
        border: 1px solid #e4e4e4;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }

  border-bottom: 1px solid #e4e4e4;
}
</style>